import { render, staticRenderFns } from "./ToggleSwitcher.vue?vue&type=template&id=584a5fc4"
import script from "./ToggleSwitcher.vue?vue&type=script&lang=js"
export * from "./ToggleSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ToggleSwitcher.vue?vue&type=style&index=0&id=584a5fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports